export interface CreateLabelOptions {
  name: string;
  position?: number;
  parent_key?: string;
}

export interface GetLabelsResponse {
  data: Array<GetLabelsResponseData>;
  meta: GetLabelsResponseMeta;
}

export interface GetLabelsResponseData {
  id: string;
  type: string;
  attributes: {
    name: string;
    path: Array<string>;
    position: number;
    depth: number;
  };
}

export interface GetLabelsResponseMeta {
  current_page: number;
  next_page: number | null;
  prev_page: number | null;
  total_pages: number;
  total_count: number;
}

export interface LabelTree {
  children: Array<LabelTreeChild>;
}

export interface LabelTreeChild extends GetLabelsResponseData {
  title: string;
  name: string;
  key: string;
  children: Array<LabelTreeChild>;
  expanded: boolean;
}

// type guard for LabelTreeChild vs LabelTree
export const isLabelTreeChild = (tree: LabelTree | LabelTreeChild): tree is LabelTreeChild => (tree as LabelTreeChild).id !== undefined;
